import { render, staticRenderFns } from "./vats.vue?vue&type=template&id=e67d17b0&"
import script from "./vats.vue?vue&type=script&lang=ts&"
export * from "./vats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports